<template>
    <div class="container">
        <!-- <div class="row profile">
            <div class="col col-12">
                <p>Strona w budowie</p>
            </div>
        </div> -->
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">Quizy</h2>
                <p class="paragraph">Lorem ipsum dolor sit amet, consectetur. Cras id tempor tortor, vel vestibulum urna.</p>
            </div>
            <div class="col col-8" v-bind:class="{'pending': pagination.pending}">
                <div v-if="quizes.length > 0">
                    <table class="invoices__table">
                        <tr>
                            <th width="80">ID</th>
                            <th>Nazwa</th>
                            <th>Data dodania</th>
                            <th></th>
                        </tr>
                        <tr v-for="(quiz, index) in quizes" v-bind:class="{ 'invoices__table-inactive': !quiz.canISolve }">
                            <td>{{ quiz.id }}</td>
                            <td>{{ quiz.name }}</td>
                            <td>{{ quiz.created_at }}</td>
                            <td class="calendar__item-link">
                                <router-link :to="{name: 'Quiz', params: { id: quiz.id }}" v-if="quiz.canISolve">&raquo;</router-link>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="row">
                    <div class="col-12">
                        <pagination class="pagination-wraper" v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
                    </div>
                </div>
                <div class="row profile" v-if="quizes.length == 0">
                    <div class="col col-12">
                        <p>brak quizów</p>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'QuizesComponent',
  components: {
      
  },
  data () {
    return {
        quizes: [],
        pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {      
    /**
     * Get current user object.
     */
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/quizzes'
      })
    ])
    .then(Vue.axios.spread((notificationsReponse) => {

        next(vm => {
            vm.quizes = notificationsReponse.data.data.invoices
            vm.pagination = notificationsReponse.data.pagination
        })
    }))
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/quizy',
        })
    }
  },
  methods: {
        toggleDesc: function(inv) {
            inv.visible = !inv.visible
        },

        /**
         * On change paginate event.
         * 
         * @param  {int} page
         * @return void
         */
        onChangePaginate(page) {
            let vm = this

            vm.pagination.pending = true

            Vue.axios({
                method: 'get',
                url: '/quizzes',
                params: {
                    page: page
                }
            })
            .then(response => {
                vm.quizes = response.data.data.invoices
                vm.pagination = response.data.pagination
                vm.pagination.pending = false
            })
            .catch(error => vm.pagination.pending = false)
        }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/quizes/QuizesComponent.vue